import { useLocation } from "react-router-dom";

import { useScopedRouteParams } from "./useScopedRouteParams";

/**
 * Returns the pathname with the `/platform/:p/entity/:o` scope prefix stripped
 * off. Use for comparisons against literal route paths so they keep working
 * regardless of whether the URL happens to be scoped.
 *
 * Example:
 *   url:       /platform/12/entity/34/transactions
 *   returns:   /transactions
 *
 *   url:       /transactions
 *   returns:   /transactions
 */
export const useScopeRelativePathname = (): string => {
  const { isScoped, restPath } = useScopedRouteParams();
  const { pathname } = useLocation();
  if (!isScoped) return pathname;
  return `/${restPath}`;
};
